// this is the new one, the rest in this folder may be deprecated...

import { values } from 'ramda'
import PropMapper from '@v/util/PropMapper.js'
import DealProductType from '@v/bookings/edit/models/DealProductType.js'

export default class BookingForEditorApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BookingUpsertApiModel', instance: this, rawModel })
      .mapOptionalObject('Booking', x => new BookingUpsertApiModel(x))
      .mapArray('Products', x => x) // todo: model
      .mapArray('Resources', x => x) // todo: model
      .mapArray('Classifications', x => new BusinessUnitVisitorClassificationApiModel(x))
  }
}

// ============== Booking ==============

class BookingUpsertApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BookingUpsertApiModel', instance: this, rawModel })
      .mapString('Key')
      .mapString('BusinessUnitKey')
      .mapString('Number')
      .mapString('Reference')
      .mapNumber('NumberOfPersons')
      .mapArray(
        'NumberOfPersonsPerClassification',
        x => new BookingPersonsPerClassificationApiModel(x),
      )
      .mapString('InvoiceNumber')
      .mapArray('BookingProducts', x => new BookingProductApiModel(x))
      .mapObject('MainBooker', x => x) // todo: model (obsolete?)
      .mapString('StartTime')
  }
}

class BookingPersonsPerClassificationApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BookingPersonsPerClassificationApiModel', instance: this, rawModel })
      .mapString('ClassificationCode')
      .mapArray('NumberOfPersonsPerSegment', x => new BookingPersonsPerSegmentApiModel(x))
  }
}

class BookingPersonsPerSegmentApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BookingPersonsPerSegmentApiModel', instance: this, rawModel })
      .mapString('SegmentCode')
      .mapString('SegmentNameSingle')
      .mapString('SegmentNamePlural')
      .mapNumber('NumberOfPersons')
  }
}

class BookingProductApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BookingProductApiModel', instance: this, rawModel })
      .mapString('Key')
      .mapString('Exclusivity')
      .mapString('FromDateTimeUTC')
      .mapString('ProductGroupProductKey')
      .mapString('ProductGroupKey')
      .mapString('ProductGroupName')
      .mapString('ProductKey')
      .mapString('ProductName')
      .mapOneOf('DealProductType', values(DealProductType))
      .mapString('ResourceKey')
      .mapNumber('ProductQuantity')
      .mapArray('QuantitiesPerClassification', x => x) // todo
      .mapBool('NeedsToBeScheduled')
      .mapNumber('QuantityInProductGroup')
      .mapOneOf('ProductActiveState', ['Active', 'Inactive', 'Deleted'])
      .mapOneOf('ProductGroupActiveState', ['Active', 'Inactive', 'Deleted'])
    this.CheckinDateTimeUTC = null
    this.CheckoutDateTimeUTC = null
    this.tempId = new Date().getTime() // needed to prevent nonscheduled product switch from influencing others
  }
}

// ============== Products ==============

// todo

// ============== Resources ==============

// todo

// ============== Classifications ==============

class BusinessUnitVisitorClassificationApiModel {
  constructor(rawModel) {
    new PropMapper({ name: 'BusinessUnitVisitorClassificationApiModel', instance: this, rawModel })
      .mapArray('Segments', x => x) // todo
      .mapString('LocalizedName')
      .mapString('BusinessUnitKey')
      .mapString('Code')
      .mapString('Name')
      .mapString('Description')
      .mapBool('Mandatory')
      .mapBool('Enabled')
  }
}
